import React, { Component } from 'react';
import throttle from 'lodash.throttle';
import { connect } from 'react-redux';
import './Home.module.scss';

/**
 * Import components
 */
import Agenda from 'components/Agenda/Agenda';
import Planning from 'components/Planning/Planning';
import Popup from 'components/UI/Popup/Popup';
import Menu from 'components/UI/Menu/Menu';

import scrollStop from 'utilities/scroll-stop';

/**
 * Import FontAwesome
 */
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { agendaStart, agendaEnd } from 'actions/agenda/index.js';
import eventIndex from 'actions/event/index';
import conflictIndex from 'actions/conflict/index';

const cardWidth = 204;

const mapStateToProps = (state, props) => {
    return {
        user: state.authentication.user,
        agenda: state.agenda
    };
};

const mapDispatchToProps = {
    agendaStart,
    agendaEnd,
    eventIndex,
    conflictIndex
};

class Home extends Component {

    constructor() {
        super();
        this.state = {
            showMenu: false,
            showInput: false,
            showPlanning: true,
            showAgenda: true,
            daysFuture: 14,
            daysPast: 14,
            isLoading: false,
            initials: '',
            isDragging: false,
            scrollOffset: 14 * cardWidth
        };

        this.switchInput        = this.switchInput.bind(this);
        this.switchMenu         = this.switchMenu.bind(this);
        this.switchPlanning     = this.switchPlanning.bind(this);
        this.switchAgenda       = this.switchAgenda.bind(this);
        this.handleScrollSync   = throttle(this.handleScrollSync.bind(this), 50);
        this.addFutureDays      = this.addFutureDays.bind(this);
        this.addPastDays        = this.addPastDays.bind(this);
        this.handleDragUpdate   = this.handleDragUpdate.bind(this);
        this.goToToday          = this.goToToday.bind(this);
        this.getInitials        = this.getInitials.bind(this);
        this.goToDate           = this.goToDate.bind(this);
    }

    switchInput(e) {
        e.stopPropagation();
        this.state.showInput ? this.setState({ showInput: false }) : this.setState({ showInput: true });
    }

    switchMenu(e) {
        this.state.showMenu ? this.setState({ showMenu: false }) : this.setState({ showMenu: true });
    }

    getInitials(name) {

        let trimName = name.trim();
        var split = trimName.split(' ');

        var abbreviation = '';
        var firstLetter = '';
        var lastLetter = '';

        //Take first letter of first index in array
        firstLetter = split[0][0] ? split[0][0] : '';
        //Check if array is longer than 1 -> Then we have multiple names in the array. Check if the last index is not empty -> Otherwise render '' instead of undefined.
        lastLetter = split.length > 1 ? (split[(split.length - 1)] ? split[(split.length - 1)][0] : '') : '';
        
        abbreviation = firstLetter + lastLetter;

        this.setState({
            initials: abbreviation
        });

    }

    switchPlanning() {
        if (this.state.showPlanning) {
            if (this.state.showAgenda) {
                this.setState({ showPlanning: false }); 
            } else {
                this.setState({ showPlanning: false, showAgenda: true }); 
            }
        } else {
            this.setState({ showPlanning: true });
        }
    }

    switchAgenda() {
        if (this.state.showAgenda) {
            if (this.state.showPlanning) {
                this.setState({ showAgenda: false }); 
            } else {
                this.setState({ showAgenda: false, showPlanning: true }); 
            }
        } else {
            this.setState({ showAgenda: true });
        }
    }

    handleScrollSync(type) {

        const agenda = document.querySelector('#agenda');
        const planning = document.querySelector('#planning');
        type == 'Agenda' ? planning.scrollLeft = agenda.scrollLeft : agenda.scrollLeft = planning.scrollLeft;

        if (this.state.isLoading) return;

        //calculate the amount of cards that fit in the screen
        let fitInscreen  = window.innerWidth / cardWidth;
        //calculate how many items have been scrolled out of view to the left hand side of the screen
        let cardsOutsideScreen = planning.scrollLeft / cardWidth;
        //calculate how many days we have left outside of the screen to the right hand side
        let daysFutureLeft = ((this.state.daysFuture + this.state.daysPast) - (fitInscreen + cardsOutsideScreen));

        //if we have fewer then 7 screens to the right, we want to fetch some new days in the future
        if (daysFutureLeft < 7) {
            this.addFutureDays();
        }
        //console.warn(cardsOutsideScreen);
        //if we have fewer then 7 screens waiting outside of the left hand side we want to fetch some more days from the past
        if (cardsOutsideScreen < 7) {
            this.addPastDays();
        }

    }

    addFutureDays() {

        // console.warn('Futurte daysn added')
        //check if we are dragging, if so: do not add future days
        if (this.state.isDragging) {
            return;
        }

        this.setState({ isLoading: true });
        let today;

        if (this.props.match.params.centerDay) {
            today = new Date(this.props.match.params.centerDay);
        } else {
            today = new Date();
        }
        this.props.agendaEnd(today.setDate(today.getDate() + (this.state.daysFuture + 14)));

        this.setState({ daysFuture: (this.state.daysFuture + 14) });
        // console.warn('now future');
        this.props.eventIndex({});
        this.setState({ isLoading: false });
    }

    addPastDays() {

        //check if we are dragging, if so: do not add past days
        if (this.state.isDragging) {
            return;
        }

        this.setState({ isLoading: true });
        let today;

        if (this.props.match.params.centerDay) {
            today = new Date(this.props.match.params.centerDay);
        } else {
            today = new Date();
        }
        this.props.agendaStart(today.setDate(today.getDate() - (this.state.daysPast + 7)));
        this.setState({ daysPast: (this.state.daysPast + 7), scrollOffset: this.state.scrollOffset + (7* cardWidth) });
        // console.warn('now past');
        this.props.eventIndex({});
        this.setState({ isLoading: false });

        //because the scrolling scrollOffset is calculated from the left hand side,
        //we need to adjust the scrollLeft as soon as we add these cards to prevent
        //we keep our position (i.e. show the older days we just added)

        const agenda = document.querySelector('#agenda');
        const planning = document.querySelector('#planning');
        
        planning.scrollLeft += (7*cardWidth); // 7 because we add 7 days
        agenda.scrollLeft += (7*cardWidth);
    }

    //this function recieves a drag status from the Planning component. We need this to disable adding past or future days because react-beautiful-dnd does not support adding Droppables during a drag
    handleDragUpdate(status) {
        if (status === true) {
            this.setState({ isDragging: true });
        } else {
            this.setState({ isDragging: false });
        }
    }

    goToToday() {

        let todayObject = new Date();

        if (todayObject >= this.props.agenda.start && todayObject <= this.props.agenda.end ) {
            let today = document.querySelector('#CardToday');
            document.querySelector('#agenda').scrollLeft = 99999;
            today.scrollIntoView(false);
            document.querySelector('#agenda').scrollLeft += -10;

            this.setState({
                scrollOffset: this.state.daysPast * cardWidth
            });
        } else {
            this.props.history.push('/agenda');
        }

        
    }

    goToDate(date) {
        let dateObject = new Date(date);

        if (dateObject >= this.props.agenda.start && dateObject <= this.props.agenda.end ) {
            let dateString = date.split('-');
            dateString = `${dateString[2]}${dateString[1]}${dateString[0]}`;
            if (dateString.startsWith('0')) {
                dateString = dateString.substring(1);
            }
            let day = document.getElementById(`${dateString}`);
            document.querySelector('#agenda').scrollLeft = 99999;
            day.scrollIntoView(false);
            document.querySelector('#agenda').scrollLeft += -10;

            this.setState({
                scrollOffset: this.state.daysPast * cardWidth
            });

        } else {
            this.props.history.push(`/agenda/${date}`);
        }

    }

    componentDidMount() {

        this.getInitials(this.props.user && this.props.user.name);

        if (this.props.match.params.centerDay) {
            let today = new Date(this.props.match.params.centerDay);
            this.props.agendaStart(today.setDate(today.getDate() - 14));
            this.props.agendaEnd(today.setDate(today.getDate() + 28));
        }

        const agenda = document.querySelector('#agenda');
        const planning = document.querySelector('#planning');

        scrollStop(agenda,() => this.handleScrollSync('Agenda'));
        scrollStop(planning,() => this.handleScrollSync('Planning'));

        //we have 14 days in the past, so we need to adjust the scroll so we start with 'today' in view
        planning.scrollLeft = (14*cardWidth);
        agenda.scrollLeft = (14*cardWidth);

        //get conflicts
        this.props.conflictIndex();

    }

    componentDidUpdate(prevProps) {
        if (prevProps.match.params.centerDay && prevProps.match.params.centerDay != this.props.match.params.centerDay) {
            let today;
            if (this.props.match.params.centerDay) {
                today = new Date(this.props.match.params.centerDay);
            } else {
                today = new Date();
            }
            this.props.agendaStart(today.setDate(today.getDate() - 14));
            this.props.agendaEnd(today.setDate(today.getDate() + 28));
            setTimeout(() => this.props.eventIndex({}), 300);
            const agenda = document.querySelector('#agenda');
            const planning = document.querySelector('#planning');
            planning.scrollLeft = (14*cardWidth);
            agenda.scrollLeft = (14*cardWidth);

        }
        if (!prevProps.match.params.centerDay && this.props.match.params.centerDay) {
            let today = new Date(this.props.match.params.centerDay);
            this.props.agendaStart(today.setDate(today.getDate() - 14));
            this.props.agendaEnd(today.setDate(today.getDate() + 28));
            setTimeout(() => this.props.eventIndex({}), 300);
            const agenda = document.querySelector('#agenda');
            const planning = document.querySelector('#planning');
            planning.scrollLeft = (14*cardWidth);
            agenda.scrollLeft = (14*cardWidth);
        }
    }

    render() {    
        const { showAgenda, showPlanning } = this.state;
        return (
            <div styleName='home-background'>
                <Popup handleClose={this.switchMenu} visible={this.state.showMenu} click={this.switchMenu}>
                    <Menu handleClose={this.switchMenu} open={this.state.showMenu} click={this.switchMenu} onInputClick={this.handleDirectInput} initials={this.state.initials}/>
                </Popup>
            
                <Agenda daysFuture={this.state.daysFuture} 
                    daysPast={this.state.daysPast} 
                    centerDay={this.props.match.params.centerDay}
                    switchMenu={this.switchMenu} 
                    switchAgenda={this.switchAgenda} 
                    showAgenda={showAgenda} 
                    nextMonday={this.state.scrollNextMonday} 
                    prevMonday={this.state.scrollPrevMonday} 
                    goToToday={this.goToToday}
                    goToDate={this.goToDate}
                    handleDragUpdate={this.handleDragUpdate}
                    initials={this.state.initials}/>

                <Planning handleDragUpdate={this.handleDragUpdate} daysFuture={this.state.daysFuture} daysPast={this.state.daysPast} centerDay={this.props.match.params.centerDay} showPlanning={showPlanning} switchPlanning={this.switchPlanning}/>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);